import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Row, Col, Checkbox, Panel, FormGroup} from 'react-bootstrap';
import {Form, Errors, Control, actions} from 'react-redux-form';
import RequiredSelect from '../common/form/elements/required-select';
import ArrowButton from '../common/button-arrow';
import {saveStaffRewards} from '../../actions/staff';

class ManageRewards extends Component {
    constructor(props) {
        super(props);
    }

    onRewardsUpdated= (payload) => {
        this.props.dispatch(actions.submitFields('deep.staff_rewards', saveStaffRewards(payload, this.props.storeId)))
    }

    render() {
        let form = <h2>Loading...</h2>;
        const features = this.props.features;

        if (this.props.fetched) {
            form = (
            <Col md={12}>
                <Panel className="manage-staff-rewards-panel">
                    <Form className="manage-staff-rewards-form" model="deep.staff_rewards" onSubmit={this.onRewardsUpdated}>
                        <Errors className="errors" model="deep.staff_rewards"/>
                        <Row>
                            <Col lg={12}>
                                <RequiredSelect model=".voucher_type_id"
                                                values={this.props.availableVoucherTypes}
                                                label="I would like to reward my staff with the following vouchers..."
                                                labelAttr='label'
                                                valueAttr='value'
                                                controlId="voucher_type_id"/>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <ArrowButton color="green"
                                             ghost
                                             className="pull-right"
                                             arrow={false}
                                             disabled={false}>Save changes</ArrowButton>
                            </Col>
                        </Row>
                    </Form>
                </Panel>
            </Col>
            );
        }

        return (this.props.open && form)
    }
}

const mapStateToProps = (state) => {
    return {
        storeId: state.staff.staffRewards.manageStoreId,
        fetched: state.staff.staffRewards.manageFetched,
        rewardMarkup: state.staff.staffRewards.rewardMarkup,
        availableVoucherTypes: state.staff.staffRewards.availableVoucherTypes,
        selectedVoucherType: state.deep.staff_rewards.voucher_type_id,
        autoRedeem: state.deep.staff_rewards.auto_redeem,
        availableVoucherDenominations: state.staff.staffRewards.availableVoucherDenominations || [],
        selectedVoucherDenomination: state.deep.staff_rewards.voucher_denomination_id,
        features: state.features
    }
};

export default connect(mapStateToProps)(ManageRewards);



// WEBPACK FOOTER //
// ./src/components/staff-rewards/manage-rewards.jsx